import { SafeLogErrorOptions } from '../log-error';
import { LoggableError } from './LoggableError';

export class BaseError extends LoggableError {
    constructor(message: string, loggerFields: SafeLogErrorOptions, stack?: string) {
        super(message, loggerFields, stack);

        Object.setPrototypeOf(this, BaseError.prototype);
    }
}
